<template>
  <div id="app">
    <Banner></Banner>
    <router-view />
  </div>
</template>

<script>
  import Vue from "vue";
  import services from "@/services";
  import { mapState } from "vuex";
  import Banner from "@/components/Banner";
  import "@/services/Transpiler/template/output/scripts/cde-wrapper.js";

  export default {
    name: "App",
    components: {
      Banner
    },
    created() {
      this.timer = setInterval(this.extendSession, 300000);
    },
    computed: {
      ...mapState({
        messages: "messages"
      })
    },
    methods: {
      extendSession() {
        const sfSession = Vue.$cookies.get("sfSession");
        const sfEndpoint = Vue.$cookies.get("sfEndpoint");

        services
          .extendSession({
            sfSession,
            sfEndpoint
          })
          .then(
            () => {},
            error => {
              console.error(error);

              this.$bvToast.toast(this.messages.SFDC_LOGGED_OUT.Text_vod__c, {
                solid: true,
                toaster: "b-toaster-bottom-center",
                variant: "danger"
              });

              setTimeout(() => {
                window.location.href = `${services.studioDomain}/login`;
              }, 5000);
            }
          );
      },
      cancelAutoExtendSession() {
        clearInterval(this.timer);
      }
    },
    beforeDestroy() {
      this.cancelAutoExtendSession();
    }
  };
</script>

<style lang="scss">
  #app {
  }
</style>
